import React from "react";
import { DateAndTimeGridCell } from "../common/DateAndTimeGridCell";
import { capitalize } from "../../services/Utils";
import {SDV_FEATURE_VEHICLE_STATUS} from "../../services/Constants"
import { TextField } from "@mui/material";

const FeatureStatusTypeInput = (props) => {
  return (
    <>
      <TextField
        label="Value"
        variant="standard"
        style={{ minWidth: 120 }}
        select
        SelectProps={{
          native: true,
        }}
        onChange={(event) =>
          props.applyValue({ ...props.item, value: event.target.value })
        }
      >
        {Object.entries(SDV_FEATURE_VEHICLE_STATUS).map(([key, value]) => (
          <option key={key} value={value}>
            {value}
          </option>
        ))}
      </TextField>
    </>
  );
};

const customFilterForFeatureStatusType = [
    {
      value: "equals",
      label: "Equals",
      getApplyFilterFn: (filterItem) => {
        if (!filterItem.field || !filterItem.value || !filterItem.operator) {
          return null;
        }
        return (params) => {
          return params.value.toLowerCase() === filterItem.value.toLowerCase();
        };
      },
      InputComponent: FeatureStatusTypeInput,
      InputComponentProps: { type: "string" },
    },
  ];


const getSdvFeatureVehiclesDataColumns = () => {
  return [
      {
        field: "vehicleKey",
        headerName: "Vehicle Key",
        width: 400,
      },
      {
        field: "feature_status",
        headerName: "Feature Status",
        filterable:false,
        filterOperators: customFilterForFeatureStatusType,
        width: 200,
      },
      {
        field: "createdBy",
        headerName: "Created By",
        flex: 1,
        sortable: true,
        valueFormatter: ({ value }) => capitalize(value),
      },
      {
        field: "updatedBy",
        headerName: "Updated By",
        flex: 1,
        sortable: true,
        valueFormatter: ({ value }) => capitalize(value),
      },
      {
        field: "createdAt",
        headerName: "Created At",
        flex: 1,
        editable: false,
        type: "dateTime",
        valueGetter: (value) => value ? new Date(value) : null,
        renderCell: (data) => (
          <DateAndTimeGridCell value={data?.row?.createdAt} />
        ),
      },
    ];
};

export { getSdvFeatureVehiclesDataColumns };
